import React from 'react';

const SpotlightsHomePage = () => {
  return (
    <div>We hope this is everything you have dreamed and hoped it would be</div>
  );
};

export default SpotlightsHomePage;
